module.exports = __webpack_public_path__ + "assets/img/img-hotel-03.161d862e.jpg";